// extracted by mini-css-extract-plugin
export var label = "styles-module--label--JvnVp";
export var input = "styles-module--input--Ry8kw";
export var link = "styles-module--link--tzn1F";